export const UPDATE_ADMIN_PAGE_TITLE = '@app/UPDATE_ADMIN_PAGE_TITLE'
export const updateAdminPageTitlePane = (title) => ({
    type: UPDATE_ADMIN_PAGE_TITLE,
    title : title,
})



// WEBPACK FOOTER //
// ./src/App/SolutionEditor/actions.js